<template lang="pug">
router-link.card.no-decoration(
  :to="{ name: 'app.notaRecebida', params: { id: nota.id } }"
)
  .card-body
    .float-right
      i.fa.fa-chevron-right.text-primary
    .columns
      .column.col-12
        text-output(label="Prestador", :text="prestador")
      .column.col-4.col-xs-12
        text-output(label="Número", :text="nota.numero")
      .column.col-4.col-xs-12
        text-output(label="Valor ISS", :text="nota.valor_iss | currency('R$')")
      .column.col-4.col-xs-12
        text-output(
          label="Valor serviços",
          :text="nota.valor_servicos | currency('R$')"
        )
  .card-footer.d-flex.justify-content-between.align-items-center
    .text-small.text-gray {{ nota.created_at | date }}
    .text-small.text-gray {{ nota.situacao.descricao }}
</template>

<script>
export default {
  props: { nota: { type: Object, required: true } },
  computed: {
    prestador() {
      return `${this.$options.filters.cpfCnpj(this.nota.prestador.cpf_cnpj)} ${
        this.nota.prestador.razao_social
      }`;
    },
  },
};
</script>
